import React from 'react';
import { useOutletContext } from 'react-router-dom';
import Plans from '../../components/Plans';

export default function PlansPage() {
  const ctx = useOutletContext();
  return <Plans {...ctx} />;
}
